import { useLang } from 'hooks/lang';

import { Column, Row, Tooltip, ComponentOrNode } from 'components/Blocks';

import { listGet } from 'utils/array';
import { REPRICE_REASONS } from 'utils/constants';
import { InfoIcon } from 'components/Icons';

interface RepriceReasonProps {
  reason: string;
}

export function RepriceReason({ reason }: RepriceReasonProps) {
  const { t } = useLang();

  const config = listGet(REPRICE_REASONS, reason, 'value');

  if (!config) return null;

  const { getDescription, getLabel, icon } = config;

  return (
    <Row gap="2" alignItems="flex-start" className="rounded-md border p-2">
      <ComponentOrNode target={icon} className="mt-1" color="primary" />

      <Column gap="1" fullWidth>
        <span className="text-primary">{getLabel(t)}</span>

        <span className="text-sm text-muted-foreground opacity-50">{getDescription(t)}</span>

        <span className="text-sm">
          <strong className="font-semibold text-warning">{t('warning')}!</strong>{' '}
          {t('ensure-reprice-reason')}.{' '}
          <strong className="font-semibold italic">{t('reprice-reason-not-apply')}.</strong>{' '}
          <Tooltip ensurePresence clickable content={t('reprice-reason-reviewed')}>
            <InfoIcon size={14} />
          </Tooltip>
        </span>
      </Column>
    </Row>
  );
}
